const cartDrawer = document.querySelector('.cart-drawer-container');

if (cartDrawer) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class'
      ) {
        if (cartDrawer.classList.contains('menu-opening')) {
            setTimeout(() => {
                BSS_B2B.nt.initFunction()
                document.dispatchEvent(new Event("DOMContentLoaded"));
            }, 1000);
        }
      }
    });
  });

  observer.observe(cartDrawer, {
    attributes: true, 
  });
}
document.addEventListener("bss_b2b:CustomCartUpdate", e => {
    setTimeout(() => {
        BSS_B2B.nt.initFunction()
        document.dispatchEvent(new Event("DOMContentLoaded"));
    }, 500);
})